// import { Fragment } from "react/jsx-runtime";
// import HeroSection from "../components/common/HeroSection";
// import data from "../aboutClinic.json";
// import OurClinic from "../components/AboutClinic/OurClinic";
// import ImageCardGrid from "../components/common/WhyImageCard";
// import LocationContact from "../components/AboutClinic/LocationContact";
// import DigitalHealthFAB from "../components/Digitalhealth";
// import { useLocation } from "react-router-dom";
// import { useEffect } from "react";
// import { splitClinicTiming, useClinicSchedule } from "../context/ClinicScheduleContext";
// import useFetch from "../hooks/useFetch";
// import { BASE_URL } from "../api/apiClient";
// import { formatTime } from "../components/OurDoctors/Book Consultation";

// const { aboutHero } = data;

// const AboutClinic = () => {
//     const heroSlides = [aboutHero.hero];
//     const location=useLocation();
//     useEffect(()=>{
//       if(!location.hash) return
//       const id=location.hash.replace("#","");
//       const timer=setTimeout(() => {
//         document.getElementById(id)?.scrollIntoView({behavior:"smooth",block:"start"})
//       }, 100);
//       return () => clearTimeout(timer);
//     },[location.hash])

// // code related to clinicTimings
// const {schedule}=useClinicSchedule();
//   const weeklySchedule = schedule?.schedulingSetup?.weeklySchedule;
//     const workingDays = weeklySchedule.filter((day) => day.working);
  
//  const formatClinicTimings = (weeklySchedule) => {
//     if (!weeklySchedule?.length) return "";
//     const dayMap = {
//       MONDAY: "Monday",
//       TUESDAY: "Tuesday",
//       WEDNESDAY: "Wednesday",
//       THURSDAY: "Thursday",
//       FRIDAY: "Friday",
//       SATURDAY: "Saturday",
//       SUNDAY: "Sunday",
//     };
//     const formatTime = (time) => {
//       if (!time) return "";
//       const [hour, minute] = time.split(":");
//       const date = new Date();
//       date.setHours(Number(hour), Number(minute));
//       return date.toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//         hour12: true,
//       });
//     };
//     if (!workingDays.length) return "";
//     const firstDay = workingDays[0];
//     const lastDay = workingDays[workingDays.length - 1];
//     const startTime = firstDay.timeWindows?.[0]?.startTime;
//     const endTime = firstDay.timeWindows?.[0]?.endTime;
//     const secondShiftStartTime = firstDay?.timeWindows?.[1]?.startTime;
//     const secondShiftEndTime = firstDay?.timeWindows?.[1]?.endTime;
//     // const lunchStart = firstDay.lunchBreak?.startTime;
//     // const lunchEnd = firstDay.lunchBreak?.endTime;
//     // return `${dayMap[firstDay.dayOfWeek]}-${dayMap[lastDay.dayOfWeek]} ${formatTime(
//     //   startTime
//     // )} - ${formatTime(endTime)} | Lunch: ${formatTime(
//     //   lunchStart
//     // )} - ${formatTime(lunchEnd)} && ${formatTime(secondShiftStartTime)}-${formatTime(secondShiftEndTime)}`;
//     return `${dayMap[firstDay.dayOfWeek]}-${dayMap[lastDay.dayOfWeek]} ${formatTime(
//       startTime,
//     )} - ${formatTime(endTime)} & ${formatTime(secondShiftStartTime)} - ${formatTime(secondShiftEndTime)}`;
//   };
//   const timings = formatClinicTimings(weeklySchedule);
//   const { days, timings: clinicTimings } = splitClinicTiming(timings);
//   const offDays = weeklySchedule?.filter((day) => day.working !== true);
//   const firstObj = {
//     label: `${days}`,
//     value: `${clinicTimings}`,
//   };
//   const secondObj = {
//     label: `${offDays?.[0]?.dayOfWeek}`,
//     value: "Closed",
//   };
//   const{data:aboutApiData}=useFetch(`${BASE_URL}/api/femcare/about/?clinic=femcare`);
//   console.log(schedule,"this is the dattttttttta");
// console.log(aboutApiData?.aboutHero?.hero,"hhhhhhhhhhhero");
// const heroDataFromApi=[aboutApiData?.aboutHero?.hero]
//   const rowsTobeMapped = [firstObj, secondObj];
//     const firstDay = workingDays?.[0];

//    const lunchStart = firstDay?.lunchBreak?.startTime;
//     const lunchEnd = firstDay?.lunchBreak?.endTime;
//   const lunchText=`Break Hour : ${formatTime(lunchStart)} - ${formatTime(lunchEnd)}`
//   console.log(lunchText,"tttttttttttttt");
// if(!aboutApiData) return <>Loading.....</>


//   return (
//     <Fragment>
//       <DigitalHealthFAB/>
//         <HeroSection slides={heroDataFromApi} />
//         <OurClinic aboutClinic={aboutApiData?.aboutClinic}/>
//         <ImageCardGrid data={aboutApiData?.whyOurClinic}  />
//         <LocationContact  rowsTobeMapped={rowsTobeMapped} locationContact={aboutApiData.locationContact}/>
//     </Fragment>
//   );
// };

// export default AboutClinic;

// import { Fragment } from "react/jsx-runtime";
// import HeroSection from "../components/common/HeroSection";
// import data from "../aboutClinic.json";
// import OurClinic from "../components/AboutClinic/OurClinic";
// import ImageCardGrid from "../components/common/WhyImageCard";
// import LocationContact from "../components/AboutClinic/LocationContact";
// import DigitalHealthFAB from "../components/Digitalhealth";
// import { useLocation } from "react-router-dom";
// import { useEffect } from "react";
// import {
//   splitClinicTiming,
//   useClinicSchedule,
// } from "../context/ClinicScheduleContext";
// import useFetch from "../hooks/useFetch";
// import { BASE_URL } from "../api/apiClient";
// import { formatTime } from "../components/OurDoctors/Book Consultation";

// /* ────────────────────────────────────────────────────────────────────────
//  * SCHEDULE FORMATTING HELPERS
//  * Groups consecutive days (Mon → Sun) that share identical open hours
//  * into a single row, e.g. "Monday - Friday" / "9:00 AM - 5:00 PM",
//  * "Saturday" / "9:00 AM - 2:00 PM", "Sunday" / "Closed".
//  * Works regardless of how many timeWindows a day has (1 window, split
//  * shift with 2 windows, or 0 when closed).
//  * ──────────────────────────────────────────────────────────────────── */

// const DAY_ORDER = [
//   "MONDAY",
//   "TUESDAY",
//   "WEDNESDAY",
//   "THURSDAY",
//   "FRIDAY",
//   "SATURDAY",
//   "SUNDAY",
// ];

// const DAY_LABELS = {
//   MONDAY: "Monday",
//   TUESDAY: "Tuesday",
//   WEDNESDAY: "Wednesday",
//   THURSDAY: "Thursday",
//   FRIDAY: "Friday",
//   SATURDAY: "Saturday",
//   SUNDAY: "Sunday",
// };

// // A stable string that's identical for two days iff they have the same
// // working/closed status AND the same time windows in the same order.
// const getDaySignature = (day) => {
//   if (!day?.working) return "closed";
//   const windows = (day.timeWindows || [])
//     .map((w) => `${w.startTime}-${w.endTime}`)
//     .join(",");
//   return `open:${windows}`;
// };

// const formatDayLabel = (fromDay, toDay) =>
//   fromDay === toDay
//     ? DAY_LABELS[fromDay]
//     : `${DAY_LABELS[fromDay]} - ${DAY_LABELS[toDay]}`;

// const formatWindowsValue = (day) => {
//   if (!day?.working) return "Closed";
//   const windows = day.timeWindows || [];
//   if (!windows.length) return "Closed";
//   return windows
//     .map((w) => `${formatTime(w.startTime)} - ${formatTime(w.endTime)}`)
//     .join(" & ");
// };

// // Returns rows like:
// // [{ label: "Monday - Friday", value: "9:00 AM - 5:00 PM" },
// //  { label: "Saturday", value: "9:00 AM - 2:00 PM" },
// //  { label: "Sunday", value: "Closed" }]
// const buildScheduleRows = (weeklySchedule) => {
//   if (!weeklySchedule?.length) return [];

//   // Re-order into a fixed Mon → Sun sequence regardless of API order.
//   const byDay = Object.fromEntries(weeklySchedule.map((d) => [d.dayOfWeek, d]));
//   const ordered = DAY_ORDER.map((key) => byDay[key]).filter(Boolean);

//   const rows = [];
//   let groupStart = 0;

//   for (let i = 1; i <= ordered.length; i++) {
//     const prevSig = getDaySignature(ordered[i - 1]);
//     const currSig = i < ordered.length ? getDaySignature(ordered[i]) : null;

//     if (currSig !== prevSig) {
//       const fromDay = ordered[groupStart].dayOfWeek;
//       const toDay = ordered[i - 1].dayOfWeek;
//       rows.push({
//         label: formatDayLabel(fromDay, toDay),
//         value: formatWindowsValue(ordered[groupStart]),
//       });
//       groupStart = i;
//     }
//   }

//   return rows;
// };

// // Picks the lunch break from the first working day that actually has one
// // enabled, instead of assuming day[0] always does (Saturday, for example,
// // often has lunchBreak.enabled: false).
// const buildLunchText = (weeklySchedule) => {
//   const dayWithLunch = weeklySchedule?.find(
//     (d) => d.working && d.lunchBreak?.enabled && d.lunchBreak?.startTime
//   );
//   if (!dayWithLunch) return "";
//   const { startTime, endTime } = dayWithLunch.lunchBreak;
//   return `Break Hour : ${formatTime(startTime)} - ${formatTime(endTime)}`;
// };

// const AboutClinic = () => {
//   const location = useLocation();
//   useEffect(() => {
//     if (!location.hash) return;
//     const id = location.hash.replace("#", "");
//     const timer = setTimeout(() => {
//       document
//         .getElementById(id)
//         ?.scrollIntoView({ behavior: "smooth", block: "start" });
//     }, 100);
//     return () => clearTimeout(timer);
//   }, [location.hash]);

//   const { schedule } = useClinicSchedule();
//   const weeklySchedule = schedule?.schedulingSetup?.weeklySchedule;

//   const rowsTobeMapped = buildScheduleRows(weeklySchedule);
//   const lunchText = buildLunchText(weeklySchedule);

//   const { data: aboutApiData } = useFetch(
//     `${BASE_URL}/api/femcare/about/?clinic=mukta`
//   );

//   const heroDataFromApi = [aboutApiData?.aboutHero?.hero];

//   if (!aboutApiData) return <>Loading.....</>;

//   return (
//     <Fragment>
//       <DigitalHealthFAB />
//       <HeroSection slides={heroDataFromApi} />
//       <OurClinic aboutClinic={aboutApiData?.aboutClinic} />
//       <ImageCardGrid data={aboutApiData?.whyOurClinic} />
//       <LocationContact
//         lunchText={lunchText}
//         rowsTobeMapped={rowsTobeMapped}
//         locationContact={aboutApiData.locationContact}
//       />
//     </Fragment>
//   );
// };

// export default AboutClinic;
import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../aboutClinic.json";
import OurClinic from "../components/AboutClinic/OurClinic";
import ImageCardGrid from "../components/common/WhyImageCard";
import LocationContact from "../components/AboutClinic/LocationContact";
import DigitalHealthFAB from "../components/Digitalhealth";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import {
  splitClinicTiming,
  useClinicSchedule,
} from "../context/ClinicScheduleContext";
import useFetch from "../hooks/useFetch";
import { BASE_URL } from "../api/apiClient";
import { formatTime } from "../components/OurDoctors/Book Consultation";

/* ────────────────────────────────────────────────────────────────────────
 * SCHEDULE FORMATTING HELPERS
 * Groups consecutive days (Mon → Sun) that share identical open hours
 * AND identical lunch breaks into a single row, so e.g.:
 *   Mon-Fri 9-5, lunch 1-2
 *   Sat 9-4, lunch 2-3        (different hours AND different lunch → own row)
 *   Sun Closed
 * ──────────────────────────────────────────────────────────────────── */

const DAY_ORDER = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

const DAY_LABELS = {
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
};

// A stable string that's identical for two days iff they have the same
// working/closed status, the same time windows (in order), AND the same
// lunch break. Two days only merge into one row if all three match.
const getDaySignature = (day) => {
  if (!day?.working) return "closed";
  const windows = (day.timeWindows || [])
    .map((w) => `${w.startTime}-${w.endTime}`)
    .join(",");
  const lunch = day.lunchBreak?.enabled
    ? `${day.lunchBreak.startTime}-${day.lunchBreak.endTime}`
    : "none";
  return `open:${windows}|lunch:${lunch}`;
};

const formatDayLabel = (fromDay, toDay) =>
  fromDay === toDay
    ? DAY_LABELS[fromDay]
    : `${DAY_LABELS[fromDay]} - ${DAY_LABELS[toDay]}`;

const formatWindowsValue = (day) => {
  if (!day?.working) return "Closed";
  const windows = day.timeWindows || [];
  if (!windows.length) return "Closed";
  return windows
    .map((w) => `${formatTime(w.startTime)} - ${formatTime(w.endTime)}`)
    .join(" & ");
};

const formatLunchValue = (day) => {
  if (!day?.working || !day.lunchBreak?.enabled || !day.lunchBreak?.startTime) {
    return "";
  }
  const { startTime, endTime } = day.lunchBreak;
  return `Break Hour : ${formatTime(startTime)} - ${formatTime(endTime)}`;
};

// Returns rows like:
// [{ label: "Monday - Friday", value: "9:00 AM - 5:00 PM", lunchText: "Break Hour : 1:00 PM - 2:00 PM" },
//  { label: "Saturday", value: "9:00 AM - 4:00 PM", lunchText: "Break Hour : 2:00 PM - 3:00 PM" },
//  { label: "Sunday", value: "Closed", lunchText: "" }]
const buildScheduleRows = (weeklySchedule) => {
  if (!weeklySchedule?.length) return [];

  // Re-order into a fixed Mon → Sun sequence regardless of API order.
  const byDay = Object.fromEntries(weeklySchedule.map((d) => [d.dayOfWeek, d]));
  const ordered = DAY_ORDER.map((key) => byDay[key]).filter(Boolean);

  const rows = [];
  let groupStart = 0;

  for (let i = 1; i <= ordered.length; i++) {
    const prevSig = getDaySignature(ordered[i - 1]);
    const currSig = i < ordered.length ? getDaySignature(ordered[i]) : null;

    if (currSig !== prevSig) {
      const fromDay = ordered[groupStart].dayOfWeek;
      const toDay = ordered[i - 1].dayOfWeek;
      const repDay = ordered[groupStart]; // representative day for this group
      rows.push({
        label: formatDayLabel(fromDay, toDay),
        value: formatWindowsValue(repDay),
        lunchText: formatLunchValue(repDay),
      });
      groupStart = i;
    }
  }

  return rows;
};

const AboutClinic = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = setTimeout(() => {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => clearTimeout(timer);
  }, [location.hash]);

  const { schedule } = useClinicSchedule();
  const weeklySchedule = schedule?.schedulingSetup?.weeklySchedule;

  const rowsTobeMapped = buildScheduleRows(weeklySchedule);

  const { data: aboutApiData } = useFetch(
    `${BASE_URL}/api/femcare/about/?clinic=femcare`
  );
// <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.449180772107!2d78.3605938!3d17.438202249999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb939359bc5b67%3A0x5e5a312899a0f8db!2sGreenland%20Colony%2C%20Madhava%20Reddy%20Colony%2C%20Gachibowli%2C%20Hyderabad%2C%20Telangana%20500032!5e0!3m2!1sen!2sin!4v1785328996014!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
  const heroDataFromApi = [aboutApiData?.aboutHero?.hero];

  if (!aboutApiData) return <>Loading.....</>;

  return (
    <Fragment>
      <DigitalHealthFAB />
      <HeroSection slides={heroDataFromApi} />
      <OurClinic aboutClinic={aboutApiData?.aboutClinic} />
      <ImageCardGrid data={aboutApiData?.whyOurClinic} />
      <LocationContact
        rowsTobeMapped={rowsTobeMapped}
        locationContact={aboutApiData.locationContact}
      />
    </Fragment>
  );
};

export default AboutClinic;